import { render, staticRenderFns } from "./DropDownDivider.vue?vue&type=template&id=475fe3a8&"
import script from "./DropDownDivider.vue?vue&type=script&lang=js&"
export * from "./DropDownDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports